import type { PerspectiveRef } from "./deltas";
import type { ViewRef } from "./perspectives";

export function viewKey(ref: ViewRef): string {
  return ref.type === "spectator" ? "spectator" : `perspective:${ref.handle}`;
}

/**
 * The views a perspectives target reaches, each once. A distribution list reaches the
 * perspectives on it at the time, as `listMembers` reports them.
 */
export function reachedViews(
  refs: readonly PerspectiveRef[],
  listMembers: (listId: string) => Iterable<string> | undefined,
): ViewRef[] {
  const reached = new Map<string, ViewRef>();
  for (const ref of refs) {
    if (ref.type !== "distributionList") {
      reached.set(viewKey(ref), ref);
      continue;
    }
    for (const handle of listMembers(ref.id) ?? []) {
      const member: ViewRef = { type: "perspective", handle };
      reached.set(viewKey(member), member);
    }
  }
  return [...reached.values()];
}
